var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{ref:"map",class:[_vm.$style.map, 'map']}),_c('buttons',{on:{"zoomIn":_vm.zoomIn,"zoomOut":_vm.zoomOut,"centroid":_vm.centroid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }